declare global {
  interface Window {
    google?: any;
    googleTranslateElementInit?: () => void;
  }
}

export const GOOGLE_TRANSLATE_LANGUAGES = ["en", "pt", "fr", "de"];

const GOOGLE_TRANSLATE_COOKIE = "googtrans";
const SOURCE_LANGUAGE = "en";

const setCookie = (name: string, value: string) => {
  document.cookie = `${name}=${value};path=/`;
  const hostname = window.location.hostname;
  if (hostname.includes(".")) {
    document.cookie = `${name}=${value};path=/;domain=.${hostname.replace(/^www\./, "")}`;
  }
};

export const setGoogleTranslateLanguage = (language: string) => {
  const normalizedLanguage = GOOGLE_TRANSLATE_LANGUAGES.includes(language) ? language : "en";

  if (normalizedLanguage === SOURCE_LANGUAGE) {
    setCookie(GOOGLE_TRANSLATE_COOKIE, "");
    return;
  }

  setCookie(GOOGLE_TRANSLATE_COOKIE, `/${SOURCE_LANGUAGE}/${normalizedLanguage}`);
};

export const applyGoogleTranslateLanguage = (language: string) => {
  const normalizedLanguage = GOOGLE_TRANSLATE_LANGUAGES.includes(language) ? language : "en";
  setGoogleTranslateLanguage(normalizedLanguage);

  const combo = document.querySelector(".goog-te-combo") as HTMLSelectElement | null;
  if (combo) {
    combo.value = normalizedLanguage;
    combo.dispatchEvent(new Event("change"));
  }
};

export const applyGoogleTranslateLanguageWhenReady = (language: string) => {
  const normalizedLanguage = GOOGLE_TRANSLATE_LANGUAGES.includes(language) ? language : "en";
  setGoogleTranslateLanguage(normalizedLanguage);

  let attempts = 0;
  const interval = window.setInterval(() => {
    const combo = document.querySelector(".goog-te-combo") as HTMLSelectElement | null;
    if (combo || normalizedLanguage === SOURCE_LANGUAGE || attempts >= 20) {
      applyGoogleTranslateLanguage(normalizedLanguage);
      window.clearInterval(interval);
      return;
    }
    attempts += 1;
  }, 300);

  return () => window.clearInterval(interval);
};

export const initializeGoogleTranslate = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (!document.getElementById("google_translate_element")) {
    const element = document.createElement("div");
    element.id = "google_translate_element";
    element.setAttribute("aria-hidden", "true");
    element.style.position = "fixed";
    element.style.left = "-9999px";
    element.style.top = "0";
    document.body.appendChild(element);
  }

  if (!window.googleTranslateElementInit) {
    window.googleTranslateElementInit = () => {
      if (!window.google?.translate?.TranslateElement) {
        return;
      }

      new window.google.translate.TranslateElement(
        {
          pageLanguage: SOURCE_LANGUAGE,
          includedLanguages: GOOGLE_TRANSLATE_LANGUAGES.join(","),
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };
  }

  if (!document.querySelector('script[data-google-translate="true"]')) {
    const script = document.createElement("script");
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    script.setAttribute("data-google-translate", "true");
    document.body.appendChild(script);
  } else if (window.google?.translate?.TranslateElement && window.googleTranslateElementInit) {
    window.googleTranslateElementInit();
  }
};
